module.exports = __webpack_public_path__ + "static/media/base_impact_water.15699bad.png";